export default __webpack_public_path__ + "static/media/chevron-left.inline.66f0207e.svg";